import { css } from '@emotion/react';

/*
 * Usage:
 *
 * const StyledDiv = styled.div`
 *   ${ ellipsis };
 * `;
 */
export const ellipsis = `
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const ellipsisInFlexChild = css`
  min-width: 0;
  ${ellipsis};
`;
